const envDomain = "dev.cyberskiller.com";

export const environment = {
  displayedDomain: `pja.${envDomain}`,
  production: true,
  apiLocation: "/api/",
  apiDomain: `https://api.${envDomain}`,
  wsLocation: `wss://api.${envDomain}/ws/`,
  judge0ApiLocation: `https://judge.${envDomain}/`,
  captchaMocked: false,
  defaultLang: "pl",
};
